import {IonIcon} from "@ionic/react";
import {documentLockOutline} from "ionicons/icons";
import React from "react";


const permissionRepositoryTypeIcons = {
    'KeyVaultAccessPolicies': '/assets/Icons/security/10245-icon-service-Key-Vaults.svg',
    'SqlServer': '/assets/Icons/databases/02390-icon-service-Azure-SQL.svg',
    'IpAccess': '/assets/Icons/networking/10084-icon-service-Firewalls.svg',
}

export default function ({type}) {
    if (type === "AspNetUserClaims")
        return <IonIcon slot="start" style={{fontSize: '24px'}} icon={documentLockOutline}></IonIcon>;
    return <IonIcon slot="start" style={{fontSize: '24px'}} src={permissionRepositoryTypeIcons[type]}></IonIcon>
}